import {push} from 'react-router-redux';
import {
    BEGIN_AJAX_CALL,
    END_AJAX_CALL,
    LAYOUT_SIDEBAR,
    SET_CURRENT_USERS_TAB,
    SET_CURRENT_USER_EDIT_TAB,
    SET_CURRENT_CONFIGURATION_TAB,
    SET_CURRENT_BLOCKS_TAB,
    SET_CURRENT_TRANSLATION_EDIT_TABS,
    SET_CURRENT_LABELS_TAB,
    SET_CURRENT_STAFF_TAB,
    SET_CURRENT_TAGS_TAB,
    SET_CURRENT_FAQS_TAB,
    SET_CURRENT_PAGES_TAB,
    SET_CURRENT_TEMPLATES_TAB,
    SET_UPLOAD_PROGRESS
} from './types';

export function toggleSideBar(open) {
    return {
        type: LAYOUT_SIDEBAR,
        payload: open
    }
}

export function beginAjaxCall() {
    return {
        type: BEGIN_AJAX_CALL
    }
}

export function endAjaxCall() {
    return {
        type: END_AJAX_CALL
    }
}

export function setUploadProgress(percent) {
    return {
        type: SET_UPLOAD_PROGRESS,
        payload: percent
    }
}

/** Pages component tabs **/
export function setCurrentPagesTab(value, pageId) {
    return {
        type: SET_CURRENT_PAGES_TAB,
        payload: {
            pageId: pageId,
            value: value
        }
    }
}

export function setPagesTab(value, id) {
    return dispatch => {
        dispatch(setCurrentPagesTab(value, id));
        if (value === 0) {
            dispatch(push(`/pages/${id}`));
        }
        if (value === 1) {
            dispatch(push(`/pages/${id}/sort`));
        }
        if (value === 2) {
            dispatch(push(`/pages/${id}/versions`));
        }
    }
}

/** Templates component tabs **/
export function setCurrentTemplatesTab(value, templateId) {
    return {
        type: SET_CURRENT_TEMPLATES_TAB,
        payload: {
            templateId: templateId,
            value: value
        }
    }
}

export function setTemplatesTab(value, id) {
    return dispatch => {
        dispatch(setCurrentTemplatesTab(value, id));
        if (value === 0) {
            dispatch(push(`/template/${id}`));
        }
        if (value === 1) {
            dispatch(push(`/template/${id}/history`));
        }
    }
}

/** Users component tabs **/
export function setCurrentUsersTab(value) {
    return {
        type: SET_CURRENT_USERS_TAB,
        payload: value
    }
}


export function setCurrentUserEditTab(value, userId) {
    return {
        type: SET_CURRENT_USER_EDIT_TAB,
        payload: {
            userId: userId,
            value: value
        }
    }
}

export function setUserEditTab(value, id) {
    return dispatch => {
        dispatch(setCurrentUserEditTab(value, id));
        if (value === 0) {
            dispatch(push(`/users/${id}`));
        }
        if (value === 1) {
            dispatch(push(`/users/${id}/permissions`));
        }
    }
}

export function setUserTab(value) {
    return dispatch => {
        dispatch(setCurrentUsersTab(value));
        if (value === 0) {
            dispatch(push('/users'));
        }
        if (value === 1) {
            dispatch(push('/roles'));
        }
    }
}

/** Blocks component tabs **/
export function setCurrentBlocksTab(value, blockId) {
    return {
        type: SET_CURRENT_BLOCKS_TAB,
        payload: {
            blockId: blockId,
            value: value
        }
    }
}

export function setBlocksTab(value, id) {
    return dispatch => {
        dispatch(setCurrentBlocksTab(value, id));
        if (value === 0) {
            dispatch(push(`/blocks/${id}`));
        }
        if (value === 1) {
            dispatch(push(`/blocks/${id}/translations`));
        }
        if (value === 2) {
            dispatch(push(`/blocks/${id}/revisions`));
        }
    }
}

export function setCurrentTranslationEditTabs(value, blockId, siteId) {
    return {
        type: SET_CURRENT_TRANSLATION_EDIT_TABS,
        payload: {
            blockId: blockId,
            siteId: siteId,
            value: value
        }
    }
}

export function setTranslationEditTabs(value, blockId, siteId) {
    return dispatch => {
        dispatch(setCurrentTranslationEditTabs(value, blockId, siteId));
        if (value === 0) {
            dispatch(push(`/blocks/${blockId}/translations/${siteId}`));
        }
        if (value === 1) {
            dispatch(push(`/blocks/${blockId}/translations/${siteId}/revisions`));
        }
    }
}

/** Configuration component tabs **/
export function setCurrentConfigurationTab(value) {
    return {
        type: SET_CURRENT_CONFIGURATION_TAB,
        payload: value
    }
}

export function setConfigurationTab(value) {
    return dispatch => {
        dispatch(setCurrentConfigurationTab(value));
        if (value === 0) {
            dispatch(push('/configuration/reviews-allocation'));
        }
        if (value === 1) {
            dispatch(push('/configure'));
        }
    }
}

/** Labels component tabs **/
export function setCurrentLabelsTab(value, labelId) {
    return {
        type: SET_CURRENT_LABELS_TAB,
        payload: {
            labelId: labelId,
            value: value
        }
    }
}

export function setLabelsTab(value, id) {
    return dispatch => {
        dispatch(setCurrentLabelsTab(value, id));
        if (value === 0) {
            dispatch(push(`/labels/${id}`));
        }
        if (value === 1) {
            dispatch(push(`/labels/${id}/translations`));
        }
    }
}

/** Staff component tabs **/
export function setCurrentStaffTab(value, staffId) {
    return {
        type: SET_CURRENT_STAFF_TAB,
        payload: {
            staffId: staffId,
            value: value
        }
    }
}

export function setStaffTab(value, id) {
    return (dispatch) => {
        dispatch(setCurrentStaffTab(value, id));
        if (value === 0) {
            dispatch(push(`/staff/${id}`));
        }
        if (value === 1) {
            dispatch(push(`/staff/${id}/translations`));
        }
    }
}

/** Tags component tabs **/
export function setCurrentTagsTab(value, tagId) {
    return {
        type: SET_CURRENT_TAGS_TAB,
        payload: {
            tagId: tagId,
            value: value
        }
    }
}

export function setTagsTab(value, id) {
    return (dispatch) => {
        dispatch(setCurrentTagsTab(value, id));
        if (value === 0) {
            dispatch(push(`/tags/${id}`));
        }
        if (value === 1) {
            dispatch(push(`/tags/${id}/translations`));
        }
    }
}

/** Faqs component tabs **/
export function setCurrentFaqsTab(value, faqId) {
    return {
        type: SET_CURRENT_FAQS_TAB,
        payload: {
            faqId: faqId,
            value: value
        }
    }
}

export function setFaqsTab(value, id) {
    return (dispatch) => {
        dispatch(setCurrentFaqsTab(value, id));
        if (value === 0) {
            dispatch(push(`/faqs/${id}`));
        }
        if (value === 1) {
            dispatch(push(`/faqs/${id}/translations`));
        }
    }
}


// WEBPACK FOOTER //
// ./src/containers/layout/actions.js